
const programs = (state, action) => {

    if (!state) {
        state = {
            items: []
        }
    }

    switch (action.type) {
        case 'ADMIN_PROGRAMS_LOAD':
        return {
            ...state,
            items: action.items
        }
        default:
        return state
    }
}

export default programs



// WEBPACK FOOTER //
// ./src/reducers/adminPrograms.js